import { render, staticRenderFns } from "./aboutQualify.vue?vue&type=template&id=43c23528&"
import script from "./aboutQualify.vue?vue&type=script&lang=js&"
export * from "./aboutQualify.vue?vue&type=script&lang=js&"
import style0 from "./aboutQualify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports